import React, { FormEvent, useContext, useEffect, useRef } from "react";
import ProjectDashboardStore from "../../app/stores/projectdashboardStore";
import LoadingComponent from "../../app/layout/LoadingComponent";
import {  Container, Grid, Header, List, Segment, Table,} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import { useState } from "react";
import { PieChart, Pie, Legend, Tooltip, ResponsiveContainer, Cell, LabelList, Label } from 'recharts';

const ProjectManagementDashboard : React.FC = () => {
  const projectdashboardStore = useContext(ProjectDashboardStore);
  const { loadProjectCounts, countStatus} = projectdashboardStore;

  useEffect(() => {
    loadProjectCounts("Mobile");
  }, []);

   if (projectdashboardStore.loadingInitial)
     return <LoadingComponent content="Loading Human Resource" />;

  return (
    <div>
    <Container  style={{marginTop: '6rem'}}>
    <Header as='h2' attached='top'>
      Mobile Projects
    </Header>
    <Segment compact attached>
    <Table basic='very' >
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell width={3}>Count</Table.HeaderCell>
        <Table.HeaderCell>Status</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
    {countStatus.map(item => (
     <Table.Row key={item.status}> 
        <Table.Cell>{item.count}</Table.Cell> 
        <Table.Cell><Link to={`/projectmanagement/mobile?status=${item.status}`} style={{ color: "blue" }}>
          {item.status}</Link></Table.Cell>       
      </Table.Row> 
    ))}
    </Table.Body>
  </Table>
  </Segment>
    </Container>
    </div>
  );
};

export default observer(ProjectManagementDashboard);
